(function() {
  var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
templates['proposalMessageResponse.tmpl'] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, stack2, functionType="function", helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data,depth1) {
  
  var buffer = "", stack1;
  buffer += "\n	";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.isDDM), {hash:{},inverse:self.program(6, program6, data),fn:self.programWithDepth(2, program2, data, depth1),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n";
  return buffer;
  }
function program2(depth0,data,depth2) {
  
  var buffer = "", stack1;
  buffer += "\n		\n		";
  stack1 = helpers['if'].call(depth0, (depth2 && depth2.showDDM), {hash:{},inverse:self.noop,fn:self.program(3, program3, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n	";
  return buffer;
  }
function program3(depth0,data) {
  
  var buffer = "", stack1, stack2, options;
  buffer += "\n			<div class=\"activity-response teacher-response fluid-container\">\n				<div class=\"col col8\">\n					<div class=\"action\">\n						";
  options = {hash:{},data:data};
  stack2 = ((stack1 = helpers.userAvatar || (depth0 && depth0.userAvatar)),stack1 ? stack1.call(depth0, (depth0 && depth0.author), options) : helperMissing.call(depth0, "userAvatar", (depth0 && depth0.author), options));
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n						<div class=\"activity-description\">\n							<a href=\"";
  options = {hash:{},data:data};
  buffer += escapeExpression(((stack1 = helpers.userPageURL || (depth0 && depth0.userPageURL)),stack1 ? stack1.call(depth0, (depth0 && depth0.author), options) : helperMissing.call(depth0, "userPageURL", (depth0 && depth0.author), options)))
    + "\">"
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.author)),stack1 == null || stack1 === false ? stack1 : stack1.teacherScreenName)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "</a> responded\n						</div>\n					</div>\n					";
  stack2 = helpers['if'].call(depth0, (depth0 && depth0.message), {hash:{},inverse:self.noop,fn:self.program(4, program4, data),data:data});
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n				</div>\n			</div>\n		";
  return buffer;
  }
function program4(depth0,data) {
  
  var buffer = "", stack1, stack2;
  buffer += "\n						<div class=\"comment\">\n							";
  stack2 = ((stack1 = (depth0 && depth0.message)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1);
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n						</div>\n					";
  return buffer;
  }

function program6(depth0,data) {
  
  var buffer = "", stack1, stack2, options;
  buffer += "\n		<div class=\"activity-response teacher-response fluid-container\">\n			<div class=\"col col8\">\n				<div class=\"action\">\n					";
  options = {hash:{},data:data};
  stack2 = ((stack1 = helpers.userAvatar || (depth0 && depth0.userAvatar)),stack1 ? stack1.call(depth0, (depth0 && depth0.author), options) : helperMissing.call(depth0, "userAvatar", (depth0 && depth0.author), options));
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n					<div class=\"activity-description\">\n						<a href=\"";
  options = {hash:{},data:data};
  buffer += escapeExpression(((stack1 = helpers.userPageURL || (depth0 && depth0.userPageURL)),stack1 ? stack1.call(depth0, (depth0 && depth0.author), options) : helperMissing.call(depth0, "userPageURL", (depth0 && depth0.author), options)))
    + "\">"
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.author)),stack1 == null || stack1 === false ? stack1 : stack1.teacherScreenName)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "</a> responded\n					</div>\n				</div>\n				";
  stack2 = helpers['if'].call(depth0, (depth0 && depth0.message), {hash:{},inverse:self.noop,fn:self.program(7, program7, data),data:data});
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n			</div>\n		</div>\n	";
  return buffer;
  }
function program7(depth0,data) {
  
  var buffer = "", stack1, stack2;
  buffer += "\n					<div class=\"comment\">\n						";
  stack2 = ((stack1 = (depth0 && depth0.message)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1);
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n					</div>\n				";
  return buffer;
  }

function program9(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n	";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.isTeacher), {hash:{},inverse:self.noop,fn:self.program(10, program10, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n";
  return buffer;
  }
function program10(depth0,data) {
  
  var buffer = "", stack1, stack2;
  buffer += "\n		";
  stack2 = helpers.unless.call(depth0, ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.hasResponse), {hash:{},inverse:self.noop,fn:self.program(11, program11, data),data:data});
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n	";
  return buffer;
  }
function program11(depth0,data) {
  
  var buffer = "", stack1, options;
  buffer += "\n			";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.responses), {hash:{},inverse:self.noop,fn:self.program(12, program12, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n			<a class=\"reply-button button-secondary small js-reply-button\" data-original-id=\""
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.id)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\" data-original-author-salutation=\"";
  options = {hash:{},data:data};
  buffer += escapeExpression(((stack1 = helpers.escapeQuotes || (depth0 && depth0.escapeQuotes)),stack1 ? stack1.call(depth0, ((stack1 = ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.author)),stack1 == null || stack1 === false ? stack1 : stack1.salutation), options) : helperMissing.call(depth0, "escapeQuotes", ((stack1 = ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.author)),stack1 == null || stack1 === false ? stack1 : stack1.salutation), options)))
    + "\" id=\"reply-button-"
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.id)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\">Write a personalized note</a>\n		";
  return buffer;
  }
function program12(depth0,data) {
  
  
  return "\n				<div class=\"defaultMessageSent\"><svg class=\"icon icon-check\"><use xlink:href=\"/images/icon/icon-junior.svg#icon-check\"></use></svg> We sent your prewritten thank you to this donor.</div>\n			";
  }

  buffer += "\n\n\n";
  stack1 = helpers.each.call(depth0, (depth0 && depth0.responses), {hash:{},inverse:self.noop,fn:self.programWithDepth(1, program1, data, depth0),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n";
  stack2 = helpers.unless.call(depth0, ((stack1 = (depth0 && depth0.original)),stack1 == null || stack1 === false ? stack1 : stack1.apiDonation), {hash:{},inverse:self.noop,fn:self.program(9, program9, data),data:data});
  if(stack2 || stack2 === 0) { buffer += stack2; }
  buffer += "\n\n";
  return buffer;
  });
})();